import { Loading } from "@components"
import { FEATURE } from "@constants"
import { DashboardSummaryContainer } from "@containers"
import { hasFeature } from "@helpers/dashboard"
import { useGetFeatures } from "@hooks"
import { Navigate } from "react-router-dom"

const   DashboardSummaryPage = () => {
  const { isLoading, data: featureList } = useGetFeatures()
  const { logo_image } = featureList?.find(feature => feature.feature_id === FEATURE.SUMMARY_DASHBOARD) ?? { logo_image: ''}
  const isEnabled = hasFeature(featureList, FEATURE.SUMMARY_DASHBOARD)

  if (isLoading) {
    return <Loading />
  }

    if (!isEnabled) {
    return <Navigate to='/' />
  }

  return <DashboardSummaryContainer logoImage={logo_image}/>
}

export default DashboardSummaryPage
